import withTracker from './withTracker';

export default withTracker;
